import React, { Component, } from 'react'

import PropTypes from 'prop-types';

import {CCLang, CCIcon, CCFlag,  colors} from './../../cc-imports'
import './../../styles/css/components/CCGridItem/cc-grid-item.css'
import CCErrorBoundary from "../CCErrorBoundary/CCErrorBoundary";

class CCGridItem extends Component {

    static propTypes = {
        onPress:PropTypes.func,
        onLongPress:PropTypes.func,
        selected:PropTypes.bool,

        size : PropTypes.string,
        disabled : PropTypes.bool,
        type : PropTypes.string,
        item : PropTypes.object
    };

    static defaultProps = {
        onPress : ()=>{},
        onLongPress : ()=>{},
        selected:false,

        size : 'r',
        disabled : false,
        type : 'country',
        item : {}
    };

    constructor(props) {
        super(props)
        this.state = {}

        this.__getFontSize=this._getFontSize.bind(this);
        this.getDimensions=this._getDimensions.bind(this);
        this._getImage=this._getImage.bind(this);
    }

    _getImage(type, {key, flag}){
        switch (type){
            case 'country':
                return <CCFlag teamKey={flag.toLowerCase()}/>
                break;
            case 'language':
                return <CCLang imageStyle={{borderWidth:0}} code={key.toLowerCase()}/>
                break;
        }
    }

    _getDimensions(){
        var height = 60;
        switch (this.props.size){
            case 's':
                height = 45;
                break;
            case 'r':
                height = 60;
                break;
            default:
                height = 60
        }
        return height;
    }

    _getFontSize(){
        var fontSize = 12;
        switch (this.props.size){
            case 's':
                fontSize = 9;
                break;
            case 'r':
                fontSize = 12;
                break;
            default:
                fontSize = 12;
        }
        return fontSize;
    }


    render() {
        let {disabled,type,item, size,selected} = this.props;
        let dimension = this._getDimensions();
        let fontSize = this._getFontSize();

        return (
            <CCErrorBoundary>
            <div className="flex-container home-root-container"  disabled={disabled} onClick={this.props.onPress}>
                <div  className="grid-container">
                     {/*<div style={{marginLeft:30,height:50,width:40}} >*/}
                     <div>
                        {
                            this._getImage(type, item)
                        }
                     </div>

                    <h4 className="grid-font" style={{fontSize:fontSize}}>{item.name}</h4>

                </div>
                {
                    selected &&
                    <div className="flex-container grid-container2">
                        <CCIcon width={25} height={50} type={'selected'}/>
                    </div>
                }
            </div>
            </CCErrorBoundary>
        )
    }
}

export default CCGridItem


// WEBPACK FOOTER //
// ./src/app/components/CCGridItem/CCGridItem.js